import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Layout";

function formatError(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (ex) {
      setErr(formatError(ex.response?.data?.detail) || ex.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-brand-ink px-4 ml-grain">
      <div className="absolute left-6 top-6"><Logo className="text-white [&>span:first-child]:text-white" /></div>
      <div className="w-full max-w-sm rounded-3xl bg-white p-8 shadow-2xl ml-fade-up">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand text-white"><ShieldCheck className="h-6 w-6" /></span>
        <h1 className="mt-4 font-display text-2xl font-extrabold tracking-tight">Panel privado</h1>
        <p className="mt-1 text-sm text-muted-foreground">Acceso solo para administradores de MiradaLatina.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <div className="relative">
            <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Correo" className="h-12 w-full rounded-xl border border-input bg-white pl-9 pr-3 outline-none focus:ring-2 focus:ring-brand/40" />
          </div>
          <div className="relative">
            <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" className="h-12 w-full rounded-xl border border-input bg-white pl-9 pr-3 outline-none focus:ring-2 focus:ring-brand/40" />
          </div>
          {err && <p data-testid="login-error" className="rounded-lg bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700">{err}</p>}
          <button data-testid="login-submit" disabled={busy} className="h-12 w-full rounded-full bg-brand font-bold text-white hover:bg-brand-hover disabled:opacity-60">
            {busy ? "Entrando..." : "Iniciar sesión"}
          </button>
        </form>
        <Link to="/" className="mt-4 block text-center text-sm text-muted-foreground hover:text-brand">← Volver al sitio</Link>
      </div>
    </div>
  );
}
